import { colors } from '../../constants';
const MuiRating = {
  iconFilled: {
    color: colors.secondary.light
  },
  iconEmpty: {
    color: colors.oriGrey[200]
  }
};
export default MuiRating;